import React from 'react';
import useTranslations from '../../../../hooks/useTranslations';
import Animation from '../../../Animation';
import Button from '../../../Button';
import Select from '../../../engine/SelectEngine';
import { SimpleFlexContainer } from '../../../layouts/ng-layouts/Containers';
import ActionEmailTemplateEditorEngine from '../engine/ActionEmailTemplateEditorEngine';
import styled from 'styled-components/macro';
import { Grid } from '@material-ui/core';
import UsersInputBoxEngine from '../../../engine/UsersInputBoxEngine';

const _Animation = styled(Animation)`
  && {
    display: flex;
  }

  button {
    font-size: 12px;
  }
`;

const ChangeStatusView = props => {
  const t = useTranslations();
  return (
    <SimpleFlexContainer $row>
      <Select
        variant={props.variant}
        customCSS="margin-left: 0.8rem !important;"
        placeholder={t('automaions.wizard.actions.status.placeholder')}
        value={props.statusValue}
        onChange={value =>
          props.dispatch({
            type: 'update_statusData',
            payload: { status: value }
          })
        }
        options={props.options}
      />
      {props.noEmail ? null : (
        <>
          <_Animation
            in={!props.showEditEmailBtn}
            mountOnEnter
            unmountOnExit
            // timeout={700}
          >
            <Button
              onClick={props.onSendEmailClicked}
              variant="text"
              customCSS="margin-left: 0.8rem !important;"
            >
              {t('automaions.wizard.actions.status.email.button')}
            </Button>
          </_Animation>
          <Animation
            in={props.showEditEmailBtn}
            type="collapse"
            mountOnEnter
            unmountOnExit
            // timeout={700}
          >
            <ActionEmailTemplateEditorEngine
              isEmailDialogOpen={props.isEmailDialogOpen}
              setIsEmailDialogOpen={props.setIsEmailDialogOpen}
              templateId={props.templateId}
              setTemplateId={props.setTemplateId}
              emailDialogProps={{
                topEndPoint: <EmailDialogRecipientSelect {...props} />,
                onCancel: props.onEmailDialogCancel,
                isConfirmBtnDisabled:
                  !props.specificUsers || !props.specificUsers.length
              }}
              onOpenEmailDialogClicked={props.onOpenEmailDialogClicked}
            />
          </Animation>
        </>
      )}
    </SimpleFlexContainer>
  );
};

const userSelectCSS = `& > div {min-height: 44px;}`;

const EmailDialogRecipientSelect = props => {
  const t = useTranslations();

  return (
    <Grid
      container
      spacing={2}
      direction="row"
      justify="flex-start"
      alignItems="center"
    >
      <Grid item sm={1}>
        To
      </Grid>
      <Grid item sm>
        {/* <Select
          fullWidth
          value={props.typesOfRecipient}
          allowMultiSelect
          dontAllowEmptyMuliSelect
          options={[
            {
              text: t('automaions.wizard.actions.email.recipient.assignedUser'),
              value: 'assignedUser',
              'data-testid': 'send-email-2-assigned-user'
            },
            {
              text: t('automaions.wizard.actions.email.recipient.specificUser'),
              value: 'specificUser',
              'data-testid': 'send-email-2-specific-user'
            }
          ]}
          onChange={props.onTypesOfRecipientChange}
          customCSS="height: 44px;"
        /> */}

        <Animation
          mountOnEnter
          unmountOnExit
          type="collapse"
          in={props.showUserSelectionDD}
        >
          <UsersInputBoxEngine
            value={props.specificUsers}
            onChange={props.onUsersSelectChange}
            customCSS={userSelectCSS}
            placeholder={t(
              'automaions.wizard.actions.email.recipient.specificUser.placeholder'
            )}
          />
        </Animation>
      </Grid>
    </Grid>
  );
};

export default ChangeStatusView;
